export const GET_REVIEW_PROPERTIES = "GET_REVIEW_PROPERTIES";
export const GET_REVIEWS_FOR_PROPERTY = "GET_REVIEWS_FOR_PROPERTY";
export const DELETE_REVIEW = "DELETE_REVIEW";
